export const approvalWorkflowsPtBr = {
  approvalPattern: 'Padrão de aprovação',
  approvalPatterns: {
    placeholder: 'Selecione um padrão',
    auto: {
      label: 'Automática',
      description: 'Sistema aprova automaticamente sem intervenção humana.',
    },
    single: {
      label: 'Apenas 1',
      description: 'Um aprovador específico deve aprovar.',
    },
    anyOf: {
      label: 'Qualquer um',
      description: 'Qualquer aprovador do grupo pode aprovar.',
    },
    allSequential: {
      label: 'Todos em sequência',
      description: 'Todos devem aprovar na ordem definida.',
    },
    allParallel: {
      label: 'Todos em paralelo',
      description: 'Todos devem aprovar; a ordem não importa.',
    },
  },
  requiredApprovalCount: 'Quantidade mínima de aprovações',
  approvers: 'Aprovadores',
  addApprover: 'Adicionar aprovador',
  addFirstApprover: 'Adicionar primeiro aprovador',
  noApprovers: 'Nenhum aprovador configurado',
  approverCount: '{{count}} aprovador(es)',
  approverType: 'Tipo de aprovador',
  approverTypes: {
    placeholder: 'Selecione um tipo',
    specificUsers: {
      label: 'Usuários específicos',
      description: 'Selecione usuários que irão aprovar.',
      helper: 'Os usuários selecionados receberão a solicitação de aprovação.',
      short: '{{count}} usuário(s)',
    },
    role: {
      label: 'Função',
      description: 'Resolve todos os usuários da função informada.',
      helper: 'Todos os usuários com a função selecionada poderão aprovar.',
      short: 'Função',
    },
    costCenterOwner: {
      label: 'Dono do centro de custo',
      description: 'Resolve para o dono do centro de custo do título.',
      helper: 'O responsável do centro de custo será resolvido dinamicamente com base na conta.',
      short: 'Resp. CC',
    },
    departmentHead: {
      label: 'Chefe do departamento',
      description: 'Resolve para o chefe do departamento do solicitante.',
      helper: 'O chefe do departamento será resolvido dinamicamente com base na conta.',
      short: 'Chefe Dept.',
    },
    billRequesterManager: {
      label: 'Gerente do solicitante',
      description: 'Resolve para o gerente do solicitante do título.',
      helper: 'O gestor do solicitante será resolvido dinamicamente.',
      short: 'Gestor',
    },
    userApprovalAuthority: {
      label: 'Autoridade de aprovação',
      description: 'Usuários com autoridade de aprovação suficiente.',
      helper: 'Usuários com limite de aprovação adequado serão resolvidos dinamicamente.',
      short: 'Autoridade',
    },
  },
  approverUsers: 'Selecionar aprovadores',
  masterApprovers: {
    title: 'Aprovadores globais',
    description:
      'Aprovadores globais são usados em escalações de timeout e para situações excepcionais. Eles podem aprovar qualquer conta, mesmo que não estejam no fluxo original.',
    label: 'Aprovadores globais',
    placeholder: 'Selecione usuários',
  },
  approverRole: 'Selecionar função',
  recipientType: 'Tipo de destinatário',
  recipientTypes: {
    placeholder: 'Selecione um tipo',
    specificUsers: {
      label: 'Usuários específicos',
      description: 'Notifica usuários selecionados.',
      helper: 'Resolve diretamente pelos usuários selecionados.',
    },
    role: {
      label: 'Função',
      description: 'Notifica todos os usuários da função.',
      helper: 'Usa a função para localizar os destinatários.',
    },
    costCenterOwner: {
      label: 'Dono do centro de custo',
      description: 'Notifica o dono do centro de custo do título.',
      helper: 'Usa o centro de custo do título para encontrar o dono.',
    },
    departmentHead: {
      label: 'Chefe do departamento',
      description: 'Notifica o chefe do departamento do solicitante.',
      helper: 'Usa o departamento do solicitante para encontrar o chefe.',
    },
  },
  recipientUsers: 'Selecionar destinatários',
  recipientRole: 'Selecionar função',
  approvalStepFallback: 'Etapa de aprovação',
  approvalPatternsLabel: 'Padrão',
  timeoutSummary: '{{hours}}h • {{action}}',
  timeout: {
    label: 'Timeout',
    actions: {
      placeholder: 'Selecione a ação',
      remind: { label: 'Relembrar', description: 'Enviar lembrete aos aprovadores.' },
      escalate: { label: 'Escalar', description: 'Escalar para outro usuário.' },
      autoApprove: {
        label: 'Aprovar automaticamente',
        description: 'Aprovar automaticamente após o prazo.',
      },
    },
  },
  timeoutHours: 'Horas até timeout',
  timeoutHoursPlaceholder: 'Ex: 24',
  timeoutAction: 'Ação no timeout',
  timeoutActionRequired: 'Selecione a ação no timeout.',
  escalateTo: 'Escalar para',
  excludeBillRequester: 'Excluir solicitante da aprovação',
  excludeBillRequesterDescription: 'Evita que o solicitante aprove a própria solicitação.',
  excludeBillRequesterShort: 'Segregar solicitante',
  approverSummary: {
    specificUsers: '{{count}} usuário(s)',
    role: 'Função: {{role}}',
    costCenterOwner: 'Dono do centro de custo',
    departmentHead: 'Chefe do departamento',
    billRequesterManager: 'Gerente do solicitante',
    unknown: 'Aprovadores não configurados',
  },
  recipientSummary: {
    users: '{{count}} destinatário(s)',
    role: 'Função: {{role}}',
    costCenterOwner: 'Dono do centro de custo',
    departmentHead: 'Chefe do departamento',
    unknown: 'Destinatário não configurado',
  },
  selectors: {
    roles: {
      label: 'Funções',
      selectedCount: '{{count}} selecionada(s)',
      search: 'Buscar por nome ou descrição...',
      empty: 'Nenhuma função encontrada.',
    },
  },
  loadingUsers: 'Carregando usuários...',
  loadingRoles: 'Carregando funções...',
  loadError: 'Não foi possível carregar usuários ou funções. Tente novamente mais tarde.',
  stepName: 'Nome da etapa',
  stepNamePlaceholder: 'Ex: Aprovação financeira',
  recipient: 'Destinatário',
  notification: 'Notificação',
  autoApprove: {
    title: 'Aprovação automática',
    badge: 'Automática',
    noReason: 'Nenhum motivo informado',
    reason: 'Motivo (opcional)',
    reasonPlaceholder: 'Ex: Valores pequenos são aprovados automaticamente',
  },
  requirePurchaseOrder: {
    title: 'Pedido de compra obrigatório',
    badge: 'PO',
    description:
      'A conta deve estar vinculada a um pedido de compra ativo antes de seguir para aprovação.',
  },
  canvas: {
    labels: {
      condition: 'Condição',
      approval: 'Aprovação',
      notification: 'Notificação',
      autoApprove: 'Aprovação automática',
      requirePurchaseOrder: 'Exigir pedido de compra',
    },
    nodeId: 'Nó',
    placeholder: 'Configure o nó nos próximos passos.',
  },
  // Refusals of a condition value, keyed by the stable code (ConditionValueErrorCode in
  // NodeConfigSheet/parsers.ts).
  conditionValueErrors: {
    BOOLEAN_VALUE_NOT_SUPPORTED: 'Por favor, insira um valor válido para a condição.',
    STRUCTURED_VALUE_INCOMPLETE:
      'Complete a condição: informe cada alíquota como número e escolha ao menos uma opção.',
  },
} as const;

export const approvalWorkflowsEn = {
  approvalPattern: 'Approval pattern',
  approvalPatterns: {
    placeholder: 'Select a pattern',
    auto: {
      label: 'Automatic',
      description: 'System auto-approves without human intervention.',
    },
    single: {
      label: 'Single',
      description: 'Exactly one approver must approve.',
    },
    anyOf: {
      label: 'Any of',
      description: 'Any approver in the group can approve.',
    },
    allSequential: {
      label: 'All sequential',
      description: 'All must approve in the defined order.',
    },
    allParallel: {
      label: 'All parallel',
      description: 'All must approve; order does not matter.',
    },
  },
  requiredApprovalCount: 'Minimum approvals required',
  approvers: 'Approvers',
  addApprover: 'Add approver',
  addFirstApprover: 'Add first approver',
  noApprovers: 'No approvers configured',
  approverCount: '{{count}} approver(s)',
  approverType: 'Approver type',
  approverTypes: {
    placeholder: 'Select a type',
    specificUsers: {
      label: 'Specific users',
      description: 'Pick the exact users who will approve.',
      helper: 'The selected users will receive the approval request.',
      short: '{{count}} user(s)',
    },
    role: {
      label: 'Role',
      description: 'Resolves all users in the chosen role.',
      helper: 'All users with the selected role can approve.',
      short: 'Role',
    },
    costCenterOwner: {
      label: 'Cost center owner',
      description: 'Resolves to the bill cost center owner.',
      helper: 'The cost center owner will be resolved dynamically based on the bill.',
      short: 'CC Owner',
    },
    departmentHead: {
      label: 'Department head',
      description: 'Resolves to the requester department head.',
      helper: 'The department head will be resolved dynamically based on the bill.',
      short: 'Dept. Head',
    },
    billRequesterManager: {
      label: 'Requester manager',
      description: 'Resolves to the requester manager.',
      helper: 'The requester manager will be resolved dynamically.',
      short: 'Manager',
    },
    userApprovalAuthority: {
      label: 'Approval authority',
      description: 'Users with sufficient approval authority.',
      helper: 'Users with adequate approval limit will be resolved dynamically.',
      short: 'Authority',
    },
  },
  approverUsers: 'Select approvers',
  masterApprovers: {
    title: 'Global approvers',
    description:
      'Global approvers are used for timeout escalations and exceptional situations. They can approve any account, even if not in the original flow.',
    label: 'Global approvers',
    placeholder: 'Select users',
  },
  approverRole: 'Select role',
  recipientType: 'Recipient type',
  recipientTypes: {
    placeholder: 'Select a type',
    specificUsers: {
      label: 'Specific users',
      description: 'Notify selected users.',
      helper: 'Resolves directly to the selected users.',
    },
    role: {
      label: 'Role',
      description: 'Notify all users in the role.',
      helper: 'Uses the role to find recipients.',
    },
    costCenterOwner: {
      label: 'Cost center owner',
      description: 'Notify the bill cost center owner.',
      helper: 'Uses the bill cost center to find the owner.',
    },
    departmentHead: {
      label: 'Department head',
      description: 'Notify the requester department head.',
      helper: 'Uses the requester department to find the head.',
    },
  },
  recipientUsers: 'Select recipients',
  recipientRole: 'Select role',
  approvalStepFallback: 'Approval step',
  approvalPatternsLabel: 'Pattern',
  timeoutSummary: '{{hours}}h • {{action}}',
  timeout: {
    label: 'Timeout',
    actions: {
      placeholder: 'Select action',
      remind: { label: 'Remind', description: 'Send a reminder to approvers.' },
      escalate: { label: 'Escalate', description: 'Escalate to another user.' },
      autoApprove: { label: 'Auto-approve', description: 'Auto-approve after the deadline.' },
    },
  },
  timeoutHours: 'Hours until timeout',
  timeoutHoursPlaceholder: 'Ex: 24',
  timeoutAction: 'Timeout action',
  timeoutActionRequired: 'Select a timeout action.',
  escalateTo: 'Escalate to',
  excludeBillRequester: 'Exclude requester from approval',
  excludeBillRequesterDescription: 'Prevents requester from approving their own request.',
  excludeBillRequesterShort: 'Segregate requester',
  approverSummary: {
    specificUsers: '{{count}} user(s)',
    role: 'Role: {{role}}',
    costCenterOwner: 'Cost center owner',
    departmentHead: 'Department head',
    billRequesterManager: 'Requester manager',
    unknown: 'Approvers not configured',
  },
  recipientSummary: {
    users: '{{count}} recipient(s)',
    role: 'Role: {{role}}',
    costCenterOwner: 'Cost center owner',
    departmentHead: 'Department head',
    unknown: 'Recipient not configured',
  },
  selectors: {
    roles: {
      label: 'Roles',
      selectedCount: '{{count}} selected',
      search: 'Search by name or description...',
      empty: 'No roles found.',
    },
  },
  loadingUsers: 'Loading users...',
  loadingRoles: 'Loading roles...',
  loadError: 'Could not load users or roles. Please try again later.',
  stepName: 'Step name',
  stepNamePlaceholder: 'Ex: Financial approval',
  recipient: 'Recipient',
  notification: 'Notification',
  autoApprove: {
    title: 'Auto-approve',
    badge: 'Automatic',
    noReason: 'No reason provided',
    reason: 'Reason (optional)',
    reasonPlaceholder: 'Ex: Low-value items auto-approved',
  },
  requirePurchaseOrder: {
    title: 'Purchase order required',
    badge: 'PO',
    description:
      'The bill must be linked to an active purchase order before proceeding to approval.',
  },
  canvas: {
    labels: {
      condition: 'Condition',
      approval: 'Approval',
      notification: 'Notification',
      autoApprove: 'Auto-approve',
      requirePurchaseOrder: 'Require purchase order',
    },
    nodeId: 'Node',
    placeholder: 'Configure this node in upcoming steps.',
  },
  conditionValueErrors: {
    BOOLEAN_VALUE_NOT_SUPPORTED: 'Enter a valid value for the condition.',
    STRUCTURED_VALUE_INCOMPLETE:
      'Complete the condition: enter each rate as a number and choose at least one option.',
  },
} as const;
